import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import OverviewPanel from "../components/predictive/OverviewPanel";
import { TEXT_PRIMARY, CARD_BORDER } from "../utils/designTokens";

const PredictivePage: React.FC = () => {
  return (
    <Box sx={{ minHeight: "100%" }}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          p: { xs: 2, md: 3 },
          backgroundColor: "#FFFFFF",
          border: `1px solid ${CARD_BORDER}`,
        }}
      >
        <Typography
          sx={{
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontSize: "1.1rem",
            fontWeight: 900,
            color: TEXT_PRIMARY,
            letterSpacing: "-0.3px",
            mb: 2,
          }}
        >
          Risk Prediction
        </Typography>
        <OverviewPanel />
      </Paper>
    </Box>
  );
};

export default PredictivePage;
